import { render, staticRenderFns } from "./OrderPage.vue?vue&type=template&id=2dc8f7ca&scoped=true&"
import script from "./OrderPage.vue?vue&type=script&lang=js&"
export * from "./OrderPage.vue?vue&type=script&lang=js&"
import style0 from "./OrderPage.vue?vue&type=style&index=0&id=2dc8f7ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc8f7ca",
  null
  
)

export default component.exports